.header {
    display: flex;
    gap: 32px;
    width: 100%;
}

.options {
    display: flex;
    width: 100%;
    padding-right: 16px;
}

.sales-options {
    justify-content: space-between;
    min-width: 850px;
}

.engagement-options {
    justify-content: space-between;
    min-width: 620px;
}

.marketing-options {
    justify-content: flex-end;
    min-width: 275px;
}
